import { alias, custom, deserialize, object, serializable } from 'serializr';
import { Base } from './base.model';
import { Deserializable } from './deserializable';
import { OnBoardingPreference } from './onboarding-preference.model';
import { ProjectPreference } from './project-preference.model';
export class UserPreferencePreference extends Base implements Deserializable {
  @serializable(alias('current', object(ProjectPreference)))
  public projectPreference: ProjectPreference;

  @serializable(object(OnBoardingPreference))
  public user_onboarding: OnBoardingPreference;

  @serializable
  public fcRestoreId: string;

  @serializable
  public overView: string;

  @serializable
  public testCaseFilterId: number;

  @serializable
  public showCommandCenterTooltip: boolean;

  @serializable(
    custom(
      (v) => v,
      (v) => v,
    ),
  )
  public testCaseReportFilterDetails: Map<string, string>;

  deserialize(input: any): this {
    return Object.assign(this, deserialize(UserPreferencePreference, input));
  }
}
